<template>
  <ul>
    <li>
      <div class="relative animate-pulse pb-8">
        <span class="bg-neutral-95 absolute left-4 top-4 -ml-px h-full w-0.5" aria-hidden="true" />
        <div class="relative flex space-x-3">
          <div>
            <span class="bg-neutral-90 flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white"> </span>
          </div>
          <div class="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
            <div class="space-y-2">
              <div class="bg-neutral-95 h-4 w-72 rounded-xl"></div>
            </div>
            <div>
              <div class="bg-neutral-95 h-4 w-8 rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </li>
    <li>
      <div class="relative animate-pulse pb-8">
        <span class="bg-neutral-95 absolute left-4 top-4 -ml-px h-full w-0.5" aria-hidden="true" />
        <div class="relative flex space-x-3">
          <div>
            <span class="bg-neutral-90 flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white"> </span>
          </div>
          <div class="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
            <div class="space-y-2">
              <div class="bg-neutral-95 h-4 w-72 rounded-xl"></div>
            </div>
            <div>
              <div class="bg-neutral-95 h-4 w-8 rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </li>
    <li>
      <div class="relative animate-pulse pb-8">
        <div class="relative flex space-x-3">
          <div>
            <span class="bg-neutral-90 flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white"> </span>
          </div>
          <div class="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
            <div class="space-y-2">
              <div class="bg-neutral-95 h-4 w-72 rounded-xl"></div>
            </div>
            <div>
              <div class="bg-neutral-95 h-4 w-8 rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>
